import type { ComponentProps, RefObject } from "react";
import { Menu, Portal } from "@ark-ui/react";
import clsx from "clsx";
import type { PanelWidth } from "@base/ui/Dropdown/types";

type Props = ComponentProps<typeof Menu.Content> & {
  container?: RefObject<HTMLElement>;
  usePortal?: boolean;
  width?: PanelWidth;
};

const Content = ({ children, className, container, usePortal = true, width = "anchor" }: Props) => {
  return (
    <Portal container={container} disabled={!usePortal}>
      <Menu.Positioner
        style={{
          width: width === "anchor" ? "var(--reference-width)" : width,
        }}
      >
        <Menu.Content
          className={clsx(
            "focus-visible:outline-none rounded-6 shadow-xs bg-white",
            "[&:is([closed],[data-closed],[data-state=closed])]:animate-fadeOut",
            "[&:is([open],[data-open],[data-state=open])]:animate-fadeIn",
            className,
          )}
        >
          {children}
        </Menu.Content>
      </Menu.Positioner>
    </Portal>
  );
};

export default Content;
